"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const common_1 = require("../StatusBar/common");
const utilities_1 = require("../../Themes/utilities");
const polished_1 = require("polished");
const Button_1 = tslib_1.__importDefault(require("../../Button"));
const Icon_1 = tslib_1.__importDefault(require("../../Icon"));
const react_1 = tslib_1.__importDefault(require("react"));
const StatusBar_1 = tslib_1.__importDefault(require("../StatusBar"));
const styled_components_1 = tslib_1.__importStar(require("../../Themes/styled-components"));
const MY_PROFILE_URL = 'https://my.sportnet.online/profile/personal-info';
const Wrapper = styled_components_1.default.div `
  padding: ${(0, polished_1.rem)(24)} ${(0, polished_1.rem)(16)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 100%;
`;
const Line = styled_components_1.default.div `
  height: ${(0, polished_1.rem)(1)};
  width: calc(100% + ${(0, polished_1.rem)(32)});
  margin: ${(0, polished_1.rem)(24)} 0;
  background-color: ${({ theme }) => theme.separatorColor};
`;
const UserName = styled_components_1.default.div `
  color: ${({ theme }) => theme.textColor};
  font-weight: 500;
  font-size: ${(0, polished_1.rem)(16)};
  text-align: center;
  margin-top: ${(0, polished_1.rem)(16)};
  margin-bottom: ${(0, polished_1.rem)(24)};
`;
const UserSubName = styled_components_1.default.div `
  margin-top: ${(0, polished_1.rem)(8)};
  color: ${({ theme }) => theme.color.fadedText};
  font-size: ${(0, polished_1.rem)(14)};
  text-align: center;
  font-weight: normal;
`;
const LogoWrapper = styled_components_1.default.div `
  height: ${({ $size }) => (0, polished_1.rem)($size)};
  width: ${({ $size }) => (0, polished_1.rem)($size)};
  display: flex;
  align-items: center;
`;
const LogoImg = styled_components_1.default.img `
  max-width: 100%;
  max-height: 100%;
  border-radius: 50%;
`;
const ChevronIcon = (0, styled_components_1.default)(Icon_1.default) `
  margin-left: ${(0, polished_1.rem)(8)};
  display: none;
  ${(0, utilities_1.mb)(550)} {
    display: initial;
  }
`;
const ResponsiveLabel = (0, styled_components_1.default)(common_1.Label) `
  display: none;
  ${(0, utilities_1.mb)('l')} {
    display: block;
    margin-left: ${(0, polished_1.rem)(12)};
  }
`;
const StatusBarUser = ({ userName, userPictureSrc, userSubName, onLogout, className, theme, loggingOut, }) => {
    const [opened, setOpened] = react_1.default.useState(false);
    const handleClose = react_1.default.useCallback(() => {
        setOpened(false);
    }, []);
    const dropdownBody = (react_1.default.createElement(Wrapper, null,
        userPictureSrc ? (react_1.default.createElement(LogoWrapper, { "$size": 80 },
            react_1.default.createElement(LogoImg, { src: userPictureSrc, alt: userName }))) : (react_1.default.createElement(Icon_1.default, { size: 80, name: "account", color: theme.color.primary })),
        react_1.default.createElement(UserName, null,
            userName,
            userSubName && react_1.default.createElement(UserSubName, null, userSubName)),
        react_1.default.createElement(Button_1.default, { as: "a", href: MY_PROFILE_URL, block: true, basic: true, target: "_blank" }, "M\u00F4j \u00FA\u010Det"),
        react_1.default.createElement(Line, null),
        react_1.default.createElement(Button_1.default, { block: true, primary: true, onClick: onLogout, loading: !!loggingOut }, "Odhl\u00E1si\u0165 sa")));
    return (react_1.default.createElement(StatusBar_1.default.DropDown, { className: className, position: "right", body: dropdownBody, opened: opened, onClose: handleClose },
        react_1.default.createElement(StatusBar_1.default.Button, { active: opened, onClick: () => {
                setOpened(o => !o);
            } },
            userPictureSrc ? (react_1.default.createElement(LogoWrapper, { "$size": 32 },
                react_1.default.createElement(LogoImg, { src: userPictureSrc, alt: userName }))) : (react_1.default.createElement(Icon_1.default, { size: "l", name: "account", color: theme.color.primary })),
            react_1.default.createElement(ResponsiveLabel, null,
                userName,
                userSubName && react_1.default.createElement(common_1.SubLabel, null, userSubName)),
            react_1.default.createElement(ChevronIcon, { name: "triangle-down", size: "m" }))));
};
exports.default = react_1.default.memo((0, styled_components_1.withTheme)(StatusBarUser));
